const blockedCountryExceptions = ['DE', 'FR'];

export default blockedCountryExceptions;
